<template>
  <ImportExport :title="$t('keywords.server.email')" type="emailserver" :headers="headers" v-on="$listeners">
    <template #item.serverName="{ item }">
      <v-text-field
        :rules="alphaNumericRules(item.serverName)"
        v-model="item.serverName"
        style="margin-bottom: -2.3vh" outlined dense
      />
    </template>

    <template #item.secureRequired="{ item }">
      <v-switch v-model="item.secureRequired" />
    </template>

    <template #item.credentialName="{ item }">
      <CredentialSelect
        :label="$t('emailserver.email_credential')"
        v-model="item.credentialName"
        :required="true"
        type="EMAIL"
      />
    </template>
  </ImportExport>
</template>

<script>
import ImportExport from '../core/ImportExport.vue'
import { alphaNumericRules, requiredRules } from '../../utils/rules'
import CredentialSelect from '../core/CredentialSelect.vue'

export default {

  components: { ImportExport, CredentialSelect },

  data: () => ({
    alphaNumericRules,
    requiredRules
  }),

  computed: {
    headers () {
      return [
        {
          text: this.$t('keywords.id'),
          value: 'serverName'
        },
        {
          text: this.$t('emailserver.required'),
          value: 'secureRequired'
        },
        {
          text: this.$t('emailserver.email_credential'),
          value: 'credentialName'
        }
      ]
    }
  }

}
</script>
